import "./Cart.module.css";
import Header from "@/reusable_sections/Header";
import Cart from "./sections/Cart";
import Footer from "@/reusable_sections/Footer";
export default function CartPage() {
  return <div>
      <Header />
      <Cart />
      <Footer />
    </div>;
}